<template>
<div>
  <span class="h4 text-center d-block mb-3">Wybierz parametry raportu</span>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.fileFormat">Należy wybrać format pliku.</small>
  </b-form-row>
  <b-form-group label="Format pliku" horizontal label-cols="5">
    <b-form-select :options="fileFormatsList" v-model="formData.fileFormat" :class="{'is-invalid': dataErrors.fileFormat}"></b-form-select>
  </b-form-group>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.title">Należy podać tytuł.</small>
  </b-form-row>
  <b-form-group label="Tytuł" horizontal label-cols="5">
    <b-form-input v-model="formData.title" :class="{'is-invalid': dataErrors.title}" placeholder="Tytuł"></b-form-input>
  </b-form-group>
  <b-form-group label="Opis" horizontal label-cols="5">
    <b-form-textarea v-model="formData.description" placeholder="Opis"></b-form-textarea>
  </b-form-group>
  <b-form-row>
    <small class="text-danger cols-sm-8 offset-sm-5" v-show="dataErrors.dataRange">Należy wybrać zasięg widoku.</small>
  </b-form-row>
  <b-form-group label="Zasięg widoku" horizontal label-cols="5">
    <b-form-select :options="dataRangesList" v-model="formData.dataRange" :class="{'is-invalid': dataErrors.dataRange}"></b-form-select>
  </b-form-group>
  <b-form-group label="Kolorystyka" horizontal label-cols="5">
    <b-form-select :options="coloursList" v-model="formData.colour"></b-form-select>
  </b-form-group>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.clause">Należy wybrać klauzulę.</small>
  </b-form-row>
  <b-form-group label="Klauzula" horizontal label-cols="5">
    <b-form-select :options="clausesList" v-model="formData.clause" :class="{'is-invalid': dataErrors.clause}" :disabled="clausesFetchInProgress"></b-form-select>
  </b-form-group>
  <b-form-group label="Elementy graficzne" horizontal label-cols="5">
    <multiselect 
      v-model="formData.elements" 
      :options="elementsList" 
      :multiple="true" 
      :close-on-select="false" 
      :hide-selected="true"
      :searchable="false" 
      select-label="Kliknij aby wybrać" 
      selected-label="Wybrano" 
      deselect-label="Kliknij aby usunąć"
      placeholder="Wybierz elementy"
      label="text"
      track-by="value">
      <template slot="noResult">Nie znaleziono elementów</template>
    </multiselect>
  </b-form-group>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.compression">Należy podać kompresję.</small>
  </b-form-row>
  <b-form-group label="Kompresja" horizontal label-cols="5">
    <b-form-input v-model="formData.compression" placeholder="0,00" class="text-right" :class="{'is-invalid': dataErrors.compression}"></b-form-input>
  </b-form-group>
  <b-form-group label="Rozdzielczość" horizontal label-cols="5">
    <b-form-select :options="resolutionsList" v-model="formData.resolution"></b-form-select>
  </b-form-group>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.coordinateSystem">Należy wybrać układ współrzędnych.</small>
  </b-form-row>
  <b-form-group label="Układ współrzędnych" horizontal label-cols="5">
    <b-form-select :options="coordinateSystemsList" v-model="formData.coordinateSystem" :class="{'is-invalid': dataErrors.coordinateSystem}"></b-form-select>
  </b-form-group>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.format">Należy wybrać format zapisu.</small>
  </b-form-row>
  <b-form-group label="Format zapisu" horizontal label-cols="5">
    <b-form-select :options="formatsList" v-model="formData.format" :class="{'is-invalid': dataErrors.format}"></b-form-select>
  </b-form-group>
  <b-form-row>
    <small class="text-danger col-sm-7 offset-sm-5" v-show="dataErrors.horizontalLayout">Należy wybrać układ strony.</small>
  </b-form-row>
  <b-form-group label="Układ strony" horizontal label-cols="5">
    <b-form-select :options="horizontalLayoutOptions" v-model="formData.horizontalLayout" :class="{'is-invalid': dataErrors.horizontalLayout}"></b-form-select>
  </b-form-group>
  <report-wizard-periodic-generation ref="periodicGeneration" :formData="formData.periodic"></report-wizard-periodic-generation>
</div>
</template>

<script>
import {
  REPORTS_RANGE_SELECTION_ACTIVATE,
  REPORTS_RANGE_SET
} from "../../store/mutations.type";

import ReportWizardPeriodicGeneration from "./ReportWizardPeriodicGeneration";
import { mapGetters } from "vuex";

export default {
  name: "ReportWizardStep2Map",
  components: {
    ReportWizardPeriodicGeneration
  },
  data: function() {
    return {
      dataErrors: {
        fileFormat: false,
        title: false,
        dataRange: false,
        clause: false,
        compression: false,
        coordinateSystem: false,
        format: false,
        horizontalLayout: false,
        periodicGeneration: false
      },
      fileFormatsList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "pdf", value: "pdf" },
        { text: "jpg", value: "jpg" },
        { text: "tiff", value: "tiff" },
        { text: "gif", value: "gif" },
        { text: "bmp", value: "bmp" },
        { text: "png", value: "png" }
      ],
      dataRangesList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "Zasięg ekranu", value: "full" },
        { text: "Wybierz zasięg", value: "custom" }
      ],
      coloursList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "Niebieski", value: "niebieski" },
        { text: "Zielony", value: "zielony" },
        { text: "Szary", value: "szary" }
      ],
      elementsList: [
        { text: "Legenda góra", value: "legendTop" },
        { text: "Legenda dół", value: "legendBottom" },
        { text: "Skala", value: "scale" },
        { text: "Kierunek północy", value: "northArrow" }
      ],
      resolutionsList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "72", value: "72" },
        { text: "96", value: "96" },
        { text: "144", value: "144" },
        { text: "200", value: "200" },
        { text: "300", value: "300" }
      ],
      coordinateSystemsList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "PL-1992", value: "EPSG:2180" },
        { text: "PL-2000 (Strefa V)", value: "EPSG:2176" },
        { text: "PL-2000 (Strefa VI)", value: "EPSG:2177" },
        { text: "PL-2000 (Strefa VII)", value: "EPSG:2178" },
        { text: "PL-2000 (Strefa VIII)", value: "EPSG:2179" }
      ],
      formatsList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "A0", value: "A0" },
        { text: "A2", value: "A2" },
        { text: "A3", value: "A3" },
        { text: "A4", value: "A4" }
      ],
      horizontalLayoutOptions:[
        { text: "Wybierz", value: undefined, disabled: true },
        { text: "Poziomy", value: true },
        { text: "Pionowy", value: false },
      ]
    };
  },
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters([
      "layers",
      "features",
      "selectedRange",
      "clauses",
      "getViewByIndex",
      "currentViewIndex",
      "clausesFetchInProgress"
    ]),
    clausesList() {
      let list = [{ text: "Wybierz", value: "", disabled: true }];

      list = list.concat(
        this.clauses.map(x => {
          return { text: x.nazwa, value: x.id };
        })
      );

      return list;
    },
    dataRange() {
      return this.formData.dataRange;
    }
  },
  methods: {
    validate() {
      const self = this;

      self.dataErrors.fileFormat = !self.formData.fileFormat;
      self.dataErrors.title = !self.formData.title;
      self.dataErrors.dataRange = !self.formData.dataRange;
      self.dataErrors.clause = !self.formData.clause;
      self.dataErrors.coordinateSystem = !self.formData.coordinateSystem;
      self.dataErrors.compression = !self.formData.compression;
      self.dataErrors.format = !self.formData.format;
      self.dataErrors.horizontalLayout = self.formData.horizontalLayout === undefined;
      self.dataErrors.periodicGeneration = !self.$refs.periodicGeneration.validate();

      return !Object.keys(self.dataErrors).some(x => self.dataErrors[x]);
    },
    getData() {
      let range = "";

      if (this.formData.dataRange === "custom") {
        range = this.$store.getters.selectedRange.getExtent();
      } else {
        range = this.getViewByIndex(this.currentViewIndex).extent;
      }
      
      const mapResolution = this.$store.getters.resolution;
      const layersId = this.layers.filter(x => x.visible && x.isVisibleInResolution(mapResolution)).sort((a, b) => b.order - a.order).map(x => x.id).join(';');

      return {
        id_warstwa: layersId,
        zasieg_widoku: range.join(","),
        format_pliku: this.formData.fileFormat,
        tytul: this.formData.title,
        opis: this.formData.description,
        elementy_graficzne: this.formData.elements.map(x => x.value),
        kompresja: (this.formData.compression || "").replace(",", "."),
        rozdzielczosc: this.formData.resolution,
        format_zapisu: this.formData.format,
        kolorystyka: this.formData.colour,
        klauzula: this.formData.clause,
        uklad_wsp: this.formData.coordinateSystem,
        poziomy: this.formData.horizontalLayout,
        aktywny: this.$refs.periodicGeneration.formData.periodicGeneration,
        data_zaplanowania: this.$refs.periodicGeneration.dateTime,
        cyklicznosc: this.$refs.periodicGeneration.formData.frequency,
        liczba_powtorzen: this.$refs.periodicGeneration.formData.repeats,
        domyslny_email: this.contextEmail,
        dodatkowe_emaile: this.$refs.periodicGeneration.formData.email
      };
    },
    reset() {
      const self = this;

      self.formData.fileFormat = "pdf";
      self.formData.title = undefined;
      self.formData.description = undefined;
      self.formData.dataRange = "full";
      self.formData.colour = "niebieski";
      self.formData.clause = "";
      self.formData.elements = [];
      self.formData.compression = "0,95";
      self.formData.resolution = "200";
      self.formData.coordinateSystem = "EPSG:2180";
      self.formData.horizontalLayout = true;
      self.formData.format = "A4";

      self.$refs.periodicGeneration.reset();

      Object.keys(self.dataErrors).forEach(x => (self.dataErrors[x] = false));
    }
  },
  watch: {
    dataRange: function(value) {
      this.$store.commit(REPORTS_RANGE_SET, undefined);

      if (value === "custom") {
        this.$store.commit(REPORTS_RANGE_SELECTION_ACTIVATE, true);
      } else {
        this.$store.commit(REPORTS_RANGE_SELECTION_ACTIVATE, false);
      }
    }
  }
};
</script>